import { Link } from "react-router-dom";
// import { IMAGES } from "../../constant/theme";
import { IMAGES } from "../../../constant/theme";
import avatar from "../../../../assets/images/avatar/1.png";
import { Fragment } from "react";
import apis from "../../../../services/apis";

const ProgressBar = [
  { title: "Photoshop", percent: "70%", color: "danger" },
  { title: "Code Editor", percent: "85%", color: "info", space: "mt-4" },
  { title: "Illustrator", percent: "65%", color: "success", space: "mt-4" },
];

const detailblog = [
  { title: "Gender", subtitle: "Male" },
  { title: "Education", subtitle: "PHD" },
  { title: "Designation", subtitle: "Sr. Professor" },
  { title: "Operation Done", subtitle: "120" },
];

const socialDetail = [
  {
    name: "Followers",
    number: "1204",
    title: "Projects",
    task: "150",
    border: "border-end",
  },
  {
    name: "Following",
    number: "2540",
    title: "Uploads",
    task: "140",
    border: "border-end",
  },
  { name: "Friends", number: "2540", title: "Tasks", task: "45" },
];

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case "sendMessage":
      return { ...state, sendMessage: !state.sendMessage };
    case "postModal":
      return { ...state, post: !state.post };
    case "linkModal":
      return { ...state, link: !state.link };
    case "cameraModal":
      return { ...state, camera: !state.camera };
    case "replyModal":
      return { ...state, reply: !state.reply };
    default:
      return state;
  }
};

const personalDetail = [
  { title: "Name", subtitle: "Mitchell C.Shay" },
  { title: "Email", subtitle: "info@example.com" },
  { title: "Country", subtitle: "India" },
  { title: "State", subtitle: "Rajasthan" },
  { title: "City", subtitle: "Udaipur" },
  { title: "Address", subtitle: "07 ashok nagar udaipur" },
];

const UserDetailProfileSection = ({ userD }) => {

  console.log("userDDD",userD)
  return (
    <>
      <div className="row mt-4">
        <div className="col-xl-3 col-xxl-4 col-lg-4">
          <div className="row">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div
                  className="text-center p-3 overlay-box"
                  style={
                    {
                      // backgroundImage: `url(${IMAGES.BigImg1})`,
                    }
                  }>
                  {userD?.cover_image ? (
                    <div className="">
                      <img
                        className="detail-cover-photo"
                        src={
                          userD?.cover_image
                            ? `${apis?.baseurl?.Baseimageurl}${userD?.cover_image}`
                            : IMAGES?.Profile
                          }
                        alt=""
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className={userD?.cover_image ? "detail-profile-photo" : ""}>
                    <img
                      src={
                        userD?.profile_image
                          ? `${apis?.baseurl?.Baseimageurl}${userD?.profile_image}`
                          : avatar
                      }
                      width=""
                      className="img-fluid rounded-circle user-detail-profile-img"
                      alt=""
                    />
                  </div>
                  <h3 className="mt-3 mb-1 text-white text-capitalize">
                    {userD?.member_name}
                  </h3>
                  <p className="text-white mb-0">{userD?.username}</p>
                </div>
                {/* <ul className="list-group list-group-flush">
                  {socialDetail?.map((data, index) => (
                    <li className="list-group-item d-flex justify-content-between" key={index}>
                      <span className="mb-0">{data?.name}</span>
                      <strong className="text-muted">{data?.number}</strong>
                    </li>
                  ))}
                </ul> */}
                {/* <div className="card-footer text-center border-0 mt-0">
                  <Link to={"#"} className="btn btn-primary px-4 me-1">
                    Follow
                  </Link>
                  <Link to={"#"} className="btn btn-warning px-4">
                    Message
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                {/* <div className="card-header">
                  <h2 className="card-title">about me</h2>
                </div> */}
                <div className="card-body pb-0">
                  {/* <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </p> */}
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex px-0 justify-content-between">
                      <strong> {userD?.user_type == "Non-ICAI" ? "Primary" : "" } Member Id</strong>
                      <span className="mb-0">{userD?.member_id}</span>
                    </li>
                    {userD?.user_type == "Non-ICAI" ?
                    <li className="list-group-item d-flex px-0 justify-content-between">
                      <strong>Secondary Member Id</strong>
                      <span className="mb-0">{userD?.alternate_member_id ? userD?.alternate_member_id :"-"}</span>
                    </li>:""
                    }

                    <li className="list-group-item d-flex px-0 justify-content-between">
                      <strong>Company Name</strong>
                      <span className="mb-0">{userD?.company_name}</span>
                    </li>

                    {/* <li className="list-group-item d-flex px-0 justify-content-between">
                      <strong>Business Card Url</strong>
                      <span className="mb-0">{userD?.business_card_url}</span>
                    </li> */}

                    {userD?.user_type == "ICAI" && (
                      <li className="list-group-item d-flex px-0 justify-content-between">
                        <strong>Zone</strong>
                        <span className="mb-0">{userD?.zone}</span>
                      </li>
                    )}
                  </ul>
                </div>
                {/* <div className="card-footer pt-0 pb-0 text-center">
                  <div className="row">
                    {socialDetail?.map((data, i) => (
                      <div className={`col-4 pt-3 pb-3 ${data.border}`} key={i}>
                        <h3 className="mb-1 text-primary">{data.task}</h3>
                        <span>{data.title}</span>
                      </div>
                    ))}
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-lg-12">
              <div className="card">
                <div className="card-header d-block">
                  <h4 className="card-title">Address </h4>
                </div>
                <div className="card-body">
                  <p className="mb-0"></p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <div className="col-xl-9 col-xxl-8 col-lg-8">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      {/* <div className="profile-about-me">
                        <div className="pt-4 border-bottom-1 pb-4">
                          <p>
                            A wonderful serenity has taken possession of my
                            entire soul, like these sweet mornings of spring
                            which I enjoy with my whole heart. I am alone, and
                            feel the charm of existence was created for the
                            bliss of souls like mine.I am so happy, my dear
                            friend, so absorbed in the exquisite sense of mere
                            tranquil existence, that I neglect my talents.
                          </p>
                          <p>
                            A collection of textile samples lay spread out on
                            the table - Samsa was a travelling salesman - and
                            above it there hung a picture that he had recently
                            cut out of an illustrated magazine and housed in a
                            nice, gilded frame.
                          </p>
                        </div>
                      </div> */}
                      <div className="profile-personal-info">
                        <h4 className="text-primary mb-4">
                          Personal Information
                        </h4>
                        <div className="row">
                          <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                Name
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.member_name}</span>
                            </div>
                          </div>

                          <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                Email
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.email ? userD?.email : "-"}</span>
                            </div>
                          </div>

                        </div>

                        <div className="row">
                        <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                Phone
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.mobile ? userD?.mobile : "-"}</span>
                            </div>
                        </div>

                        <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                WhatsApp No
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.whatsapp_number ? userD?.whatsapp_number : "-"}</span>
                            </div>
                          </div>
                        
                        </div>

                        <div className="row">
                        <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                State
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.state ? userD?.state : "-"}</span>
                            </div>
                          </div>

                          <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                City
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>{userD?.city ? userD?.city : "-"}</span>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                        <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
                              <h5 className="f-w-500">
                                Designation
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>
                                {userD?.designation ? userD?.designation : "-"}
                              </span>
                            </div>
                          </div>
                          
                          <div className="col-md-6 row mb-4">
                            <div className="col-lg-4 col-md-6 col-sm-6 col-6">
                              <h5 className="f-w-500">
                              industry
                                <span className="pull-right">:</span>
                              </h5>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-6 col-6">
                              <span>
                                {userD?.industry ? userD?.industry : "-"}
                              </span>
                            </div>
                          </div>
                        </div>

                          <div className="mb-4 d-flex gap-2">
                            <div className="">
                              <h5 className="f-w-500">
                                Business Card Url
                              </h5>
                            </div>
                            <span className="fw-bold pull-right">:</span>
                            <div className="">
                              <span>
                                {userD?.business_card_url ? userD?.business_card_url : "-"}
                              </span>
                            </div>
                          </div>
                      </div>


                      <div className="profile-skills pt-2 border-bottom-1 pb-2">
                        <h4 className="text-primary mb-4">Social</h4>
                        {userD?.website && (
                          <Link
                            to={userD?.website}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2">
                            {userD?.website}
                          </Link>
                        )}

                        {userD?.linkedin_link && (
                          <Link
                            to={userD?.linkedin_link}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.linkedin_link}
                          </Link>
                        )}

                        {userD?.instagram_link && (
                          <Link
                            to={userD?.instagram_link}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.instagram_link}
                          </Link>
                        )}

                        {userD?.facebook_link && (
                          <Link
                            to={userD?.facebook_link}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.facebook_link}
                          </Link>
                        )}

                        {userD?.twitter_link && (
                          <Link
                            to={userD?.twitter_link}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.twitter_link}
                          </Link>
                        )}

                        {userD?.snapchat_link && (
                          <Link
                            to={userD?.snapchat_link}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.snapchat_link}
                          </Link>
                        )}

                        {userD?.youtube && (
                          <Link
                            to={userD?.youtube}
                            className="btn btn-outline-dark btn-rounded px-4 me-2 mb-2"
                          >
                            {userD?.youtube}
                          </Link>
                        )}
                      </div>
                      {/* <div className="profile-lang pt-5 border-bottom-1 pb-5">
                        <h4 className="text-primary mb-4">Language</h4>
                        <span className="badge badge-primary light">
                          English
                        </span>
                        <span className="badge badge-primary light">
                          French
                        </span>
                        <span className="badge badge-primary light">
                          Bangla
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDetailProfileSection;
